import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga';
import { BrowserRouter } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
// import { AppProvider } from '@spartalabs/pdc-core';
import { AppProvider } from '@spartalabs/pdc-core';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  LineController,
  BarController,
} from 'chart.js';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import ChartAnnotationsPlugin from 'chartjs-plugin-annotation';
import { SideBar } from 'components';
import { AppRoutes } from 'routes';
import theme from 'theme';
import { GA_UA_KEY } from 'utils/constants';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';

ReactGA.initialize(GA_UA_KEY);

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(container);

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LineController,
  BarElement,
  BarController,
  Title,
  Tooltip,
  Legend,
  Filler,
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ChakraProvider resetCSS theme={theme}>
        <AppProvider>
          <SideBar>
            <AppRoutes />
          </SideBar>
        </AppProvider>
      </ChakraProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

serviceWorker.unregister();

reportWebVitals();
